define.alias("shared/components/shared/post/secondary/caption-writer/body", "calendar/components/shared/post/secondary/caption-writer/body");